import { createFileRoute } from '@tanstack/react-router'
import { Help } from '@/features/help/Help'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/help')({
  component: HelpPage,
})

function HelpPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Help" meta="How this thing works" />
      <div className="mt-6">
        <Help />
      </div>
    </div>
  )
}
